import { OFFER_TYPE } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_TYPE.BOGO]: 'Compra 1, prendi 1',
  [OFFER_TYPE.FREE_ITEM]: 'Articolo gratuito',
  [OFFER_TYPE.AMOUNT_OFF]: 'Importo scontato',
  [OFFER_TYPE.PERCENTAGE_OFF]: 'Percentuale di sconto',
};
